import { render, staticRenderFns } from "./DriverForm.vue?vue&type=template&id=00fcf869&scoped=true"
import script from "./DriverForm.vue?vue&type=script&lang=js"
export * from "./DriverForm.vue?vue&type=script&lang=js"
import style0 from "./DriverForm.vue?vue&type=style&index=0&id=00fcf869&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00fcf869",
  null
  
)

export default component.exports